module.exports = __webpack_public_path__ + "img/coins1.fbedee5b.png";